var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtc = function SvgBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M51 28c0 12.703-10.297 23-23 23S5 40.703 5 28 15.298 5 28 5s23 10.298 23 23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23 16h3v2.5h3V16h3v2.707a5.502 5.502 0 0 1 3.032 8.41A5.5 5.5 0 0 1 32.5 37.5H32v2.499h-3v-2.5h-3V40h-3v-2.5h-5v-3h3v-13h-3v-3h5zm7.5 5.5H24v5h6.5a2.5 2.5 0 0 0 0-5m-6.5 13h8.5a2.5 2.5 0 0 0 0-5H24z",
    className: "btc_svg__fill",
    clipRule: "evenodd"
  })));
};
export default SvgBtc;